import styled from 'styled-components';

export const RatchetScheduleEditStyles = styled.div`
	width: 100%;
	margin-top: 0.25rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	overflow: hidden;

	.col-shrink {
		width: 1%;
		white-space: nowrap;

		&:first-child {
			padding-left: 0.5rem;
		}

		&:last-child {
			padding-right: 0.5rem;
		}
	}

	.col-header {
		text-align: left;
	}

	table {
		border-collapse: collapse;
	}

	thead tr {
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}

	thead th {
		padding: 0.5rem 0.25rem;
		font-weight: 600;
	}

	tbody td {
		padding: 0.5rem 0.25rem;
		background: ${({ theme }) => theme.v3.colors.white[0]};
	}

	tbody tr + tr {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}

	tfoot td {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;
